import React, { useState, useEffect, useCallback } from 'react';

// 💬 Histórico de mensagens de WhatsApp do cliente (aba Mensagens da ficha).
// Junta as AGENDADAS (fila, canceláveis) com as ENVIADAS/FALHAS (histórico).

const token = () => localStorage.getItem('token');
const cab = (extra = {}) => ({ Authorization: `Bearer ${token()}`, ...extra });

const fmtDt = iso => {
  if (!iso) return '—';
  const d = new Date(iso);
  return isNaN(d) ? '—' : d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR').slice(0, 5);
};

const ST = {
  agendado: { icone: '⏳', rotulo: 'Agendada', cor: '#b45309', bg: '#fffbeb', borda: '#fde68a' },
  enviado:  { icone: '✓',  rotulo: 'Enviada',  cor: '#15803d', bg: '#f0fdf4', borda: '#bbf7d0' },
  falhou:   { icone: '✗',  rotulo: 'Falhou',   cor: '#b91c1c', bg: '#fef2f2', borda: '#fecaca' },
};

export default function HistoricoMensagens({ clienteId, aoAgendar }) {
  const [msgs, setMsgs] = useState(null);
  const [expandida, setExpandida] = useState(null);

  const carregar = useCallback(async () => {
    if (!clienteId) return setMsgs([]);
    try {
      const [hist, fila] = await Promise.all([
        fetch(`/comunicacao/historico?cliente_id=${clienteId}`, { headers: cab() }).then(r => r.ok ? r.json() : []),
        fetch('/comunicacao/fila', { headers: cab() }).then(r => r.ok ? r.json() : []),
      ]);
      const agendadas = fila.filter(m => m.cliente_id === clienteId && m.status === 'agendado');
      // Agendadas primeiro (mais próxima no topo), depois o histórico (mais recente no topo)
      agendadas.sort((a, b) => (a.agendado_para || '').localeCompare(b.agendado_para || ''));
      hist.sort((a, b) => (b.enviado_em || b.agendado_para || '').localeCompare(a.enviado_em || a.agendado_para || ''));
      setMsgs([...agendadas, ...hist]);
    } catch { setMsgs([]); }
  }, [clienteId]);

  useEffect(() => { carregar(); }, [carregar]);

  async function cancelar(m) {
    if (!window.confirm('Cancelar o envio desta mensagem?')) return;
    await fetch(`/comunicacao/fila/${m._id}`, { method: 'DELETE', headers: cab() }).catch(() => {});
    carregar();
  }

  if (!clienteId) {
    return <div style={{ color: '#6b7280', fontSize: 13, padding: 8 }}>Salve o cliente primeiro para ver as mensagens.</div>;
  }
  if (msgs === null) return <div style={{ color: '#9ca3af', fontSize: 13, padding: 8 }}>Carregando…</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ fontSize: 12.5, color: '#374151' }}>
          <strong>{msgs.length}</strong> mensagem(ns) — agendadas, enviadas e falhas deste cliente
        </div>
        {aoAgendar && (
          <button type="button" onClick={aoAgendar}
            style={{ background: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0', borderRadius: 4, padding: '4px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
            💬 Agendar nova
          </button>
        )}
      </div>
      {msgs.length === 0 ? (
        <div style={{ background: '#f9fafb', border: '1px dashed #d1d5db', borderRadius: 6, padding: 16, textAlign: 'center', color: '#9ca3af', fontSize: 12.5 }}>
          Nenhuma mensagem para este cliente ainda.
        </div>
      ) : msgs.map(m => {
        const st = ST[m.status] || ST.agendado;
        const aberta = expandida === m._id;
        return (
          <div key={m._id} onClick={() => setExpandida(aberta ? null : m._id)}
            style={{ border: `1px solid ${st.borda}`, background: st.bg, borderRadius: 6, padding: '8px 12px', marginBottom: 6, cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <div style={{ fontSize: 12, color: st.cor, fontWeight: 700, whiteSpace: 'nowrap' }}>
                {st.icone} {st.rotulo} · {fmtDt(m.status === 'agendado' ? m.agendado_para : (m.enviado_em || m.agendado_para))}
              </div>
              <div style={{ fontSize: 11, color: '#6b7280', display: 'flex', gap: 10, alignItems: 'center' }}>
                <span>📤 {m.enviar_por_nome || 'Número da empresa'}</span>
                {m.template_titulo && <span>📝 {m.template_titulo}</span>}
                {m.status === 'agendado' && (
                  <button type="button" onClick={e => { e.stopPropagation(); cancelar(m); }}
                    style={{ background: '#fff', color: '#b91c1c', border: '1px solid #fecaca', borderRadius: 4, padding: '1px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>
                    ✕ Cancelar
                  </button>
                )}
              </div>
            </div>
            <div style={{ fontSize: 12.5, color: '#374151', marginTop: 4, whiteSpace: aberta ? 'pre-wrap' : 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {m.texto_final}
            </div>
          </div>
        );
      })}
    </div>
  );
}
